<template>
  <el-select
    v-model="id"
    class="async-select"
    filterable
    placeholder="请输入收费企业关键词"
    clearable
    value-key="companyId"
    remote
    :remote-method="remoteMethod"
    :loading="selectLoading"
  >
    <el-option
      v-for="item in options"
      :key="item.companyId"
      :label="item.companyName"
      :value="item.companyId"
    >{{ item.companyName }}</el-option>
  </el-select>
</template>

<script>
import { getPurchaserOrAgencyApi } from '@/api/company'

export default {
  name: 'PurchaserOrAgencyAsyncSelect',

  model: {
    prop: 'sellerId',
    event: 'changeSellerId'
  },

  props: {
    sellerId: {
      type: [Number, String],
      default: 0
    }
  },

  data() {
    return {
      options: [],
      selectLoading: false
    }
  },

  computed: {
    id: {
      get() {
        return this.sellerId
      },
      set(val) {
        this.$emit('changeSellerId', val)
      }
    }
  },

  methods: {
    /**
     * 选择采购人或代理机构，远程搜索执行
     */
    remoteMethod(query) {
      if (query !== '') {
        this.getSellerCompanyList(query)
      } else {
        this.options = []
      }
    },

    async getSellerCompanyList(keyword = '') {
      this.selectLoading = true
      try {
        const requestParams = {
          page: 1,
          size: 10,
          keyword
        }
        const res = await getPurchaserOrAgencyApi(requestParams)
        this.options = res.data?.records || []
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '查询收费企业失败')
        }
      } finally {
        this.selectLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.async-select {
  width: 300px;
}
</style>
